// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cj-b";
export var colorBlue = "_cj-8";
export var colorDot = "_cj-0";
export var colorDotLarge = "_cj-2";
export var colorDotSmall = "_cj-1";
export var colorGreen = "_cj-7";
export var colorGrey = "_cj-3";
export var colorOrange = "_cj-5";
export var colorPink = "_cj-a";
export var colorPurple = "_cj-9";
export var colorRed = "_cj-4";
export var colorYellow = "_cj-6";